import React from 'react';
import {motion} from 'framer-motion';

const HeroSection = () => {
  return (
    <section className="relative h-screen flex items-center justify-center overflow-hidden">
      {/* Background Image */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat" 
        style={{
          backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.3)), url('https://static.wixstatic.com/media/4fbfa6_c7eee59380df4099af5173e8d4cffe29~mv2.jpg')`
        }}
      />
      
      {/* Content */}
      <div className="relative z-10 text-center text-white px-4 max-w-4xl mx-auto">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          className="text-5xl md:text-7xl font-bold mb-6 leading-tight text-white"
          style={{
            fontFamily: 'Kanit, sans-serif',
            textShadow: '2px 2px 8px rgba(0,0,0,0.7), 0 0 20px rgba(0,0,0,0.5)'
          }}
        >
          แค่หายใจก็เหนื่อย?
        </motion.h1>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          className="text-3xl md:text-4xl font-semibold mb-8 text-white"
          style={{
            fontFamily: 'Kanit, sans-serif',
            textShadow: '2px 2px 8px rgba(0,0,0,0.7), 0 0 20px rgba(0,0,0,0.5)'
          }}
        >
          ลองใช้ชีวิต "24 ซีซั่น" ดูสิ
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          className="text-xl md:text-2xl mb-12 font-light text-white"
          style={{
            fontFamily: 'Sarabun, serif',
            textShadow: '2px 2px 6px rgba(0,0,0,0.8), 0 0 15px rgba(0,0,0,0.6), 1px 1px 3px rgba(0,0,0,0.9)'
          }}
        >
          เลิกวิ่งตามโลก แล้วให้โลกหมุนตามจังหวะของคุณ
        </motion.p>

        <motion.button
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          whileHover={{ 
            scale: 1.05, 
            boxShadow: "0 10px 25px rgba(224,122,95,0.3)" 
          }}
          whileTap={{ scale: 0.95 }}
          className="bg-[#E07A5F] hover:bg-[#d16847] text-white font-bold py-4 px-8 rounded-full text-xl transition-all duration-300 shadow-lg"
          onClick={() => document.getElementById('offer-section').scrollIntoView({ behavior: 'smooth' })}
        >
          ค้นหาจังหวะที่ใช่ของฉัน
        </motion.button>
      </div>
    </section>
  );
};

export default HeroSection;